import { call, select } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { roster } from 'store/saga/entities/bound';
import { selectRouteParams } from 'selectors/general';

export function* handlePrintRosterRouteEnter(dependencies) {
  const { venueId, scheduleId } = yield select(selectRouteParams);

  yield call(fetchEntity, roster, [dependencies, venueId, scheduleId]);
}
